import { Component, Input } from '@angular/core';

import { ScheduleEventDto } from '../schedule.coaching-insight.model';

@Component({
    selector: '[cmpsScheduleItem]',
    template: ` <div>
            <div
                class="si-badge"
                [style.background-color]="item.eventStatusColour"
            >
                <span>{{ item.eventDate | date: 'EEE MMM dd' }}</span>
                <cmps-icon
                    class="ml-1"
                    svgIcon="calendar-range"
                ></cmps-icon>
            </div>
            <div
                class="si-status"
                [style.color]="item.eventStatusColour"
            >
                {{ item.eventStatusInitials }}
            </div>
        </div>
        <div class="pl-1">{{ item.eventName }}</div>`,
})
export class ScheduleItemComponent {
    @Input() item: ScheduleEventDto;
}
